import { render } from "./ItemSimilar.vue?vue&type=template&id=72b15372&scoped=true"
import script from "./ItemSimilar.vue?vue&type=script&lang=js"
export * from "./ItemSimilar.vue?vue&type=script&lang=js"

import "./ItemSimilar.vue?vue&type=style&index=0&id=72b15372&scoped=true&lang=css"

import exportComponent from "C:\\Users\\musta\\Área de Trabalho\\Projetos\\sensualle\\sensualle - pedidos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b15372"]])

export default __exports__